import { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";

interface Conversa {
  id: string;
  nome: string;
  pergunta: string;
  resposta: string;
  inclusao: number;
  avaliacao: string | null;
  id_referencia: number;
}

interface Total {
  total: number;
  avaliacao: string;
}

interface UseConversasProps {
  dataInicio?: string;
  dataFim?: string;
  pesquisar?: boolean;
  filtroAvaliacao?: number;
}

const getDefaultDates = () => {
  const today = new Date();

  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 15);
  thirtyDaysAgo.setHours(0, 0, 0, 0);

  const formatDate = (date: Date) => Math.floor(date.getTime() / 1000);

  return {
    dataInicio: formatDate(thirtyDaysAgo),
    dataFim: formatDate(today),
  };
};

export const useConversas = ({
  dataInicio,
  dataFim,
  pesquisar,
  filtroAvaliacao,
}: UseConversasProps) => {
  const [conversas, setConversas] = useState<Conversa[]>([]);
  const [total, setTotal] = useState<Total[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth();

  useEffect(() => {
    if ((!dataInicio || !dataFim) && !pesquisar) {
      return;
    }

    const controller = new AbortController();

    const fetchConversas = async () => {
      setLoading(true);
      setError(null);

      const { dataInicio: defaultInicio, dataFim: defaultFim } =
        getDefaultDates();

      const filtroInicio = Number(dataInicio || defaultInicio);
      const filtroFim = Number(dataFim || defaultFim);

      try {
        const response = await fetch(
          `https://app.sak.com.br/CentralAjudaApi/getConversas`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user?.token}`,
            },
            body: JSON.stringify({
              data_inicio: filtroInicio,
              data_fim: filtroFim + 86400,
              ajudou: filtroAvaliacao,
            }),
            signal: controller.signal,
          }
        );

        if (!response.ok) {
          throw new Error("Falha ao buscar as conversas");
        }

        const data = await response.json();

        setConversas(data.conversas || []);
        setTotal(data.total || []);
      } catch (err: any) {
        if (!controller.signal.aborted) {
          setError(`Erro ao carregar as conversas: ${err.message}`);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchConversas();
  }, [dataInicio, dataFim]);

  return { conversas, total, loading, error };
};
